import { GET_CARD_APPLY_START } from '../../types';

export const get_card_apply = (payload) => ({
  type: GET_CARD_APPLY_START,
  payload,
});
